<template>
    <div>
        <slot v-bind="{canShow, percentage, total, pending}">
            <el-popover v-if="canShow" trigger="hover" placement="top">
                <el-progress
                        slot="reference"
                        :percentage="percentage"
                        :show-text="false"
                        style="width: 80px"
                ></el-progress>
                <div class="text-center">
                    <p>Total / Left</p>
                    <p>{{ total }} / {{ pending }}</p>
                </div>
            </el-popover>
        </slot>
    </div>
</template>

<script>

  export default {
    props: {
      row: Object,
      statuses: Object,
    },

    computed: {
      /**
       * @return {boolean}
       */
      isAllowedStatus() {
        const allowed = _.chain(this.statuses)
          .pick(['sending'])
          .values()
          .value();

        return _.includes(allowed, this.status);
      },

      /**
       * @return {object}
       */
      model() {
        return this.row.model;
      },

      /**
       * @return {number}
       */
      status() {
        return _.get(this.model, 'status');
      },

      /**
       * @return {Number}
       */
      created() {
        return _.get(this.model, 'message_count', 0);
      },

      /**
       * @return {Number}
       */
      pending() {
        return _.get(this.model, 'pending_message_count', 0);
      },

      /**
       * @return {Number}
       */
      total() {
        return this.created + this.pending;
      },

      /**
       * @return {number}
       */
      percentage() {
        return this.total > 0
          ? Math.round(this.pending / this.total * 100)
          : 0;
      },

      /**
       * @return {boolean}
       */
      canShow() {
        return this.total > 0 && this.isAllowedStatus;
      },
    },

    methods: {},
  }
</script>

